<template>
  <div class="class-page">
    <el-dialog title="选择标注项目" :visible.sync="projectSelectVisible" width="420px" :close-on-click-modal="false"
      :show-close="false" :close-on-press-escape="false">
      <p class="project-select-hint">请选择本次要标注的项目（每次进入需重新选择）。</p>
      <el-radio-group v-model="pendingProjectId">
        <el-radio v-for="p in annotationProjects" :key="p.id" :label="p.id" style="display:block;margin:8px 0;">
          {{ p.displayName }}
        </el-radio>
      </el-radio-group>
      <span slot="footer">
        <el-button type="primary" :disabled="!pendingProjectId" @click="confirmProjectSelect">开始标注</el-button>
      </span>
    </el-dialog>

    <div v-if="selectedProjectId && annotationProjects.length > 1" class="project-bar">
      <span>当前项目：</span>
      <el-select v-model="selectedProjectId" size="small" @change="onProjectChange">
        <el-option v-for="p in annotationProjects" :key="p.id" :label="p.displayName" :value="p.id" />
      </el-select>
    </div>

    <div class="layout-shell">
      <aside class="category-panel">
        <el-button style="background-color: rgba(255, 87, 51,0.8)" class="ts" type="primary" plain
          @click="A">椭圆星系</el-button>
        <el-button style="background-color:rgba(63, 81, 181,0.8)" class="ts" type="primary" plain
          @click="B">侧向星系</el-button>
        <el-button style="background-color: rgba(76,175,80,0.8)" class="ts" type="primary" plain
          @click="C">旋涡星系</el-button>
        <el-button style="background-color: rgba(255,193,7,0.8)" class="ts" type="primary" plain @click="abnormal">{{
          currentCategoryLabel }}</el-button>
        <el-button style="background-color:rgba(220,91,111,0.8)" class="ts" type="primary" plain
          @click="xingXi">噪声、杂点</el-button>
      </aside>

      <section class="work-panel">
        <div class="grid-stage">
          <div ref="bb" class="gird" v-loading="loading" element-loading-text="拼命加载中"
            :style="{ paddingLeft: gutter, pointerEvents: aaaa, userSelect: bbbb }">
            <div ref="cc" @click="fun(index)" class="gird-item"
              :style="{ pointerEvents: pointerEvents, userSelect: userSelect }" v-for="(item, index) in list1"
              :key="index" id="girdChild">
              <div class="zz" ref="zz" @dblclick="double(index)"
                :style="{ width: width1, height: height1, background: background, display: display }"></div>
              <slot name="content" :item="item" :index="index"></slot>
              <img class="grid-image" :style="{ width: width, height: height }" :src="item" alt=""
                @click="chooseOne(index)" />
            </div>
          </div>
        </div>

        <div class="action-bar">
          <el-button class="action-btn analyze-btn" :style="{ background: tishi, color: color }"
            :disabled='disabledS || aiAnalyzing || aiChatLoading' :loading="aiAnalyzing" type="primary" plain
            @click="fun2(tishiIndex)">分析</el-button>
          <el-button class="action-btn submit-btn" :style="{ background: tijiao }" :disabled='disabledJ' type="primary"
            @click="fun3(tishiIndex)">提交</el-button>
        </div>
      </section>

      <aside class="chat-panel">
        <div class="chat-header">AI 对话</div>
        <div class="chat-body">
          <div class="ai-status">
            <div>当前图片：{{ currentAiImageId || '未选择' }}</div>
            <div>会话状态：{{ aiSessionId ? '已分析' : '未分析' }}</div>
          </div>

          <div ref="chatScroll" class="chat-messages">
            <div v-for="(msg, idx) in aiMessages" :key="idx" class="chat-item"
              :class="msg.role === 'user' ? 'user' : 'assistant'">
              <div class="chat-role">{{ msg.role === 'user' ? '你' : 'AI' }}</div>
              <div v-if="msg.role === 'assistant'" class="chat-content markdown" v-html="renderMarkdown(msg.content)"></div>
              <div v-else class="chat-content">{{ msg.content }}</div>
            </div>
            <div v-if="aiChatLoading" class="chat-loading">AI 正在思考...</div>
          </div>

          <div class="chat-input-wrap">
            <el-input v-model="aiQuestion" type="textarea" :rows="2" resize="none" placeholder="先点击分析，再输入问题"
              :disabled="!aiSessionId || aiAnalyzing || aiChatLoading" @keyup.enter.native="handleChatEnter" />
            <el-button class="send-btn" size="mini" type="primary" :loading="aiChatLoading"
              :disabled="!canSendAiQuestion" @click="sendAiQuestion">发送</el-button>
          </div>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { analyzeGalaxyStreamAPI, chatGalaxyStreamAPI, checkAPI, getAnnotationBatchAPI, getAnnotationProgressAPI, getResultsAPI, submitAnnotationBatchAPI, listAnnotationProjectsAPI, selectAnnotationProjectAPI } from '../API';
export default {
  name: "",
  components: {},
  props: {
    girdData: {
      type: Array,
      default: () => {
        return [

        ];
      },
    },
    // 列数
    columnNum: {
      type: String,
      default: "6",
    },
    // 格子之间的间距
    gutter: {
      type: String,
      default: "0px",
    },
    //  格子上下的间距
    gutterBottom: {
      type: String,
      default: "0px",
    },
  },
  data() {
    return {
      // 提示的次数
      is: 3,
      // 提示按钮字体颜色
      color: 'white',
      // 提交按钮的背景颜色
      tijiao: 'rgb(30,144,255)',
      // 提示按钮的背景颜色
      tishi: 'rgb(160,207,255)',
      button: 0,
      visible: false,
      // cc的取消事件
      pointerEvents: '',
      // cc
      userSelect: '',
      // bb的取消事件
      aaaa: '',
      // bb
      bbbb: '',
      cursor: '',
      // 选择变量
      chooseA: 0,
      chooseB: 0,
      chooseC: 0,
      chooseYC: 0,
      chooseXing: 0,
      display: "none",
      // 照片宽
      width: "128px",
      // 照片高
      height: "128px",
      // 遮罩层宽
      width1: "128px",
      // 遮罩层高
      height1: "128px",
      // 遮罩层颜色
      background: "rgba(135, 206, 250, 0.8)",
      str: "5*5",
      num: this.columnNum,
      list: ["4*6", "6*6", "7*7"],
      list1: this.girdData,
      // 图片下标
      xb: '',
      // 随机下标
      random1: '',
      random2: '',
      // 选中图片的下标的数组
      selected: [],
      // 椭圆类的下标
      aArray: [],
      // Edge-on类的下标
      bArray: [],
      // 螺旋类的下标
      cArray: [],
      // 异常类的下标
      ycArray: [],
      // 杂点类的下标
      xxArray: [],
      // 提示按钮状态
      disabledS: true,
      // 提交按钮状态
      disabledJ: false,
      // 去重后的新数组
      a: [],
      // 提示弹框内容
      fen: '',
      // 选中的分类数组合成的新数组
      merge: [],
      // 没有被分类的图片
      remainder: [],
      //固定下标
      arr4: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
      // 图片的全部信息
      dataFull: [],
      class0: '00.00',
      class1: '00.00',
      class2: '00.00',
      class3: '00.00',
      tishiIndex: '',
      // 判断提交之后可以继续点击提示
      submissions: 0,
      // 图片id的数组
      newArray0: [],
      newArray1: [],
      newArray2: [],
      newArray3: [],
      newArray4: [],
      newArray5: [],
      // 图片延迟加载
      // todo
      loading: true,
      // 图片的下标
      index1: '',
      time1: null,
      // 时间触发
      timebool: false,
      // 当前标注类别名称
      currentCategoryName: 'fUDGs',
      // 类别名称映射
      categoryNameMap: {
        'fUDGs': '超弥散星系',
        'Rings': '环星系',
        'DNMs': '合并星系',
        'BEs': '蓝椭圆星系'
      },
      annotationProjects: [],
      selectedProjectId: '',
      pendingProjectId: '',
      projectSelectVisible: false,
      annotationCompleted: false,
      // AI 会话信息
      aiSessionId: '',
      analyzedImageId: '',
      currentAiImageId: '',
      aiQuestion: '',
      aiAnalyzing: false,
      aiChatLoading: false,
      aiMessages: [
        { role: 'assistant', content: '请选择一张图片，点击“分析”后即可开始 AI 对话。' }
      ]
    };
  },

  computed: {
    flexBasis() {
      return 100 / Number(this.num) + "%";
    },
    // 当前类别按钮显示的标签
    currentCategoryLabel() {
      return this.categoryNameMap[this.currentCategoryName] || '异常天体';
    },
    canSendAiQuestion() {
      return !!this.aiSessionId &&
        !!(this.aiQuestion || '').trim() &&
        !this.aiChatLoading &&
        !this.aiAnalyzing;
    }
  },
  created() {
    this.initPage()
    setTimeout(() => {
      this.loading = false
    }, 2500)
  },

  methods: {
    async initPage() {
      const checked = await this.check()
      if (!checked) return
      const ready = await this.ensureProjectSelected()
      if (ready) await this.getPhotos()
    },
    async loadAnnotationProjects() {
      const res = await listAnnotationProjectsAPI()
      if (res.data.code !== 1 || !res.data.data) return false
      const data = res.data.data
      this.annotationProjects = data.projects || []
      this.selectedProjectId = ''
      this.pendingProjectId = ''
      return true
    },
    async ensureProjectSelected() {
      await this.loadAnnotationProjects()
      if (this.annotationProjects.length === 0) {
        this.$alert('当前没有开放的标注项目', '提示', { type: 'warning' })
        return false
      }
      const chosen = sessionStorage.getItem('classProjectChosen')
      if (chosen && this.annotationProjects.some(p => p.id === chosen)) {
        sessionStorage.removeItem('classProjectChosen')
        await this.selectProject(chosen)
        return true
      }
      this.pendingProjectId = ''
      this.projectSelectVisible = true
      return false
    },
    async confirmProjectSelect() {
      if (!this.pendingProjectId) return
      await this.selectProject(this.pendingProjectId)
      this.projectSelectVisible = false
      await this.getPhotos()
    },
    async selectProject(projectId) {
      const res = await selectAnnotationProjectAPI(projectId)
      if (res.data.code === 1 && res.data.data) {
        this.selectedProjectId = projectId
        this.currentCategoryName = projectId
        if (res.data.data.displayName) {
          this.categoryNameMap[projectId] = res.data.data.displayName
        }
      }
    },
    async onProjectChange(projectId) {
      try {
        await this.$confirm('切换项目后将使用该项目的独立进度，是否继续？', '提示', { type: 'warning' })
      } catch (e) {
        await this.loadAnnotationProjects()
        return
      }
      await this.selectProject(projectId)
      this.annotationCompleted = false
      await this.getPhotos()
    },
    resolveAnnotationImageUrl(picPath) {
      const rawPath = (picPath || '').trim()
      if (!rawPath) return ''
      if (/^https?:\/\//i.test(rawPath)) return rawPath

      const apiBase = process.env.VUE_APP_BASE_API || 'https://nadc.china-vo.org/galaxycircus'
      const base = apiBase.replace(/\/+$/, '')
      const relativePath = rawPath
        .replace(/\\/g, '/')
        .replace(/^(\.\/)+/, '')
        .replace(/^\/+/, '')
      return `${base}/${relativePath}`
    },
    // 校验
    async check() {
      try {
        const res = await checkAPI({})
        if (res.data.code == 1) {
          localStorage.setItem("umtId", res.data.data.toString())
          return true
        } else {
          // window.location.href = 'https://oauth.china-vo.org/oauth/authorize?response_type=code&client_id=nhjG5SWNJ1xiFuxTjK5LWWj1&redirect_uri=https%3A//nadc.china-vo.org/galaxycircus/api/callback1&scope=profile'
          return false
        }

      } catch (error) {
        if (axios.isAxiosError(error) && error.code === 'ECONNABORTED') {
          // 处理请求超时的逻辑
          this.$alert("请求超时请重试", '提示', {
            confirmButtonText: '是',
            type: 'error',
            showClose: false,
          });
        }
        return false
      }

    },
    // 获取图片
    async getPhotos() {
      try {
        // 先获取标注进度，更新当前类别名称
        const progressRes = await getAnnotationProgressAPI()
        if (progressRes.data.code == 1 && progressRes.data.data) {
          const progressData = progressRes.data.data
          if (progressData.needSelect && !this.selectedProjectId) {
            this.projectSelectVisible = true
            return
          }
          if (progressData.completed) {
            this.annotationCompleted = true
            this.$alert('恭喜！当前标注项目已完成！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              showClose: false,
            })
            return
          }
          this.currentCategoryName = progressData.categoryName || progressData.projectId || 'fUDGs'
          this.selectedProjectId = progressData.projectId || this.currentCategoryName
        }

        const res = await getAnnotationBatchAPI(this.selectedProjectId)
        if (res.data.code === 0) {
          if (!this.selectedProjectId) {
            this.$alert(res.data.message || '请先选择标注项目', '提示', { type: 'warning' })
            this.projectSelectVisible = true
          } else {
            this.$message.error(res.data.message || '获取标注批次失败')
          }
          return
        }
        if (res.data.code == 1) {
          if (res.data.data == null) {
            // 所有标注已完成
            this.annotationCompleted = true
            this.resetAiConversation()
            this.$alert("恭喜！所有标注任务已完成！", '提示', {
              confirmButtonText: '确定',
              type: 'success',
              showClose: false,
            })
            return
          }
          this.dataFull = res.data.data
          this.list1 = this.dataFull.map((item) => {
            return this.resolveAnnotationImageUrl(item.picPath)
          })
          this.tishiIndex = ''
          this.disabledS = true
          this.tishi = 'rgb(160,207,255)'
          this.resetAiConversation()
        }

      } catch (error) {
        if (axios.isAxiosError(error) && error.code === 'ECONNABORTED') {
          // 处理请求超时的逻辑
          this.$alert("请求超时请重试", '提示', {
            confirmButtonText: '是',
            type: 'error',
            showClose: false,
          });
        }
      }

    },
    // 提交结果
    async getResults(time) {
      const res = await getResultsAPI({
        umtId: window.localStorage.getItem("umtId"),
        categoryName: this.currentCategoryName,
        classInfoArr: { class0: this.newArray0, class1: this.newArray1, class2: this.newArray2, class3: this.newArray3, class4: this.newArray4, class5: this.newArray5 },
        // 异常数总数
        totalIrr: this.newArray3.length,
        // 分类的总数
        totalClassify: 24 - this.newArray5.length,
        totalTime: time
      })
      if (res.data.code == 1) {
        // 提交成功后更新用户进度
        const progressRes = await submitAnnotationBatchAPI()
        if (progressRes.data.code == 1 && progressRes.data.data) {
          const progressData = progressRes.data.data
          if (progressData.completed) {
            this.$alert("恭喜！所有标注任务已完成！感谢您的贡献！", '提示', {
              confirmButtonText: '确定',
              type: 'success',
              showClose: false,
            })
            this.annotationCompleted = true
            return
          }
        }

        this.$alert(res.data.message + '你本次的分类时间是:' + time.toFixed(0) + 's', '提示', {
          confirmButtonText: '是',
          type: 'success',
          showClose: false,
          callback: action => {
            this.getPhotos();
          }
        });
      }
    },

    // 单击选中
    fun(index) {
      if (this.timebool == false) {
        this.time1 = new Date()
        this.timebool = true
      }
      if (this.$refs.zz[index].style.display === "none") {
        this.$refs.zz[index].style.display = "block";
        this.$refs.zz[index].style.background = "rgba(135, 206, 250, 0.4)";
        if (this.$refs.zz[index].style.display == "block" && this.is != 0) {
          this.disabledS = false
          this.tishi = 'rgb(30,144,255)'
        } else {
          this.disabledS = true
          this.tishi = 'rgb(160,207,255)'
        }
        this.selected.push(index)
      } else {
        if (this.$refs.zz[index].style.background == "rgba(135, 206, 250, 0.4)") {
          this.$refs.zz[index].style.display = "none";
        }
        //检查selected中有无指定内容
        if (this.selected.includes(index)) {
          // 查指定内容的索引
          let int = this.selected.indexOf(index)
          // 如果有该索引splice删除
          this.selected.splice(int, 1)
        }
        if (this.selected.length == 0) {
          this.disabledS = true
          this.tishi = 'rgb(160,207,255)'
          this.class0 = "00.00"
          this.class1 = "00.00"
          this.class2 = "00.00"
          this.class3 = "00.00"
        }
      }
    },

    // 异常天体
    abnormal() {
      for (const i of this.selected) {
        this.ycArray.push(i)
      }
      // todo

      if (this.ycArray.length != 0) {
        this.chooseYC = 1
      }
      if (this.chooseYC == 1) {
        for (const i of this.ycArray) {
          this.$refs.zz[i].style.background = "rgba(255,193,7,0.4)";
          this.bbbb = "none"
        }
        // if (this.merge.length >= 12) {
        //   this.disabledJ = false
        //   this.disabledS = true
        //   this.tishi = 'rgb(160,207,255)'
        //   if (this.disabledJ == false) {
        //     this.tijiao = "rgb(30,144,255)"
        //   }
        // }
        this.selected = [];

      }
    },
    // 噪声杂点
    xingXi() {
      for (const i of this.selected) {
        this.xxArray.push(i)
      }

      if (this.xxArray.length != 0) {
        this.chooseXing = 1
      }
      if (this.xxArray.length == 0) {
        this.fen = "未选择分类请选择"
      }
      if (this.chooseXing == 1) {
        for (const i of this.xxArray) {
          this.$refs.zz[i].style.background = "rgb(220,91,111,0.4)";
          this.bbbb = "none"
        }
        this.selected = [];
      }
    },

    // 双击反选
    double(index) {
      if (this.$refs.zz[index].style.background !== "rgba(135, 206, 250, 0.4)") {
        this.$confirm('是否确定要撤消此图片的选择?', '提示', {
          type: 'warning',
          callback: res => {
            if ('confirm' == res) {
              this.$refs.zz[index].style.display = "none";
              if (this.aArray.includes(index)) {
                let idx = this.aArray.indexOf(index)
                this.aArray.splice(idx, 1)
              } else if (this.bArray.includes(index)) {
                let idx = this.bArray.indexOf(index)
                this.bArray.splice(idx, 1)
              } else if (this.cArray.includes(index)) {
                let idx = this.cArray.indexOf(index)
                this.cArray.splice(idx, 1)
              } else if (this.ycArray.includes(index)) {
                let idx = this.ycArray.indexOf(index)
                this.ycArray.splice(idx, 1)
              } else if (this.xxArray.includes(index)) {
                let idx = this.xxArray.indexOf(index)
                this.xxArray.splice(idx, 1)
              }

            }
          }
        })
      }
    },
    //单选图片后将索引传递至data
    chooseOne(index) {
      this.tishiIndex = index;
      this.disabledS = false
      this.tishi = 'rgb(30,144,255)'
      this.currentAiImageId = this.extractImageIdByIndex(index)
      if (this.analyzedImageId && this.currentAiImageId && this.currentAiImageId !== this.analyzedImageId) {
        this.aiSessionId = ''
        this.aiQuestion = ''
        this.aiMessages = [
          { role: 'assistant', content: '已切换到新图片，请先点击“分析”生成新会话。' }
        ]
      }
    },
    // 分析按钮：先调用 analyze 生成 sessionId
    async fun2(index) {
      if (index === '' || index === null || index === undefined) {
        this.$message.warning('请先点击一张图片，再进行分析')
        return
      }
      if (!this.dataFull[index]) {
        this.$message.warning('未找到当前图片信息')
        return
      }

      const imageId = this.extractImageIdByIndex(index)
      if (!imageId) {
        this.$message.error('无法解析 imageId，请检查图片路径')
        return
      }

      this.aiAnalyzing = true
      let streamSessionId = ''
      let streamFailed = false
      const assistantMessage = { role: 'assistant', content: '' }
      this.aiSessionId = ''
      this.aiMessages = [assistantMessage]
      this.scrollChatToBottom()

      try {
        await analyzeGalaxyStreamAPI({ imageId }, (event) => {
          if (!event || !event.type) {
            return
          }
          if (event.type === 'start') {
            streamSessionId = event.session_id || streamSessionId
          } else if (event.type === 'chunk') {
            assistantMessage.content += event.content || ''
          } else if (event.type === 'done') {
            streamSessionId = event.session_id || streamSessionId
            if (!assistantMessage.content && event.scientific_summary) {
              assistantMessage.content = event.scientific_summary
            }
          } else if (event.type === 'error') {
            streamFailed = true
            assistantMessage.content = `分析失败：${event.message || '未知错误'}`
          }
          this.scrollChatToBottom()
        })

        if (!streamFailed && streamSessionId) {
          this.aiSessionId = streamSessionId
          this.analyzedImageId = imageId
          this.currentAiImageId = imageId
          this.aiQuestion = ''
          if (!assistantMessage.content) {
            assistantMessage.content = '分析完成'
          }
          this.$message.success('分析完成，可继续 AI 对话')
        } else if (!assistantMessage.content) {
          assistantMessage.content = '分析失败：未获取到会话信息'
        }
      } catch (error) {
        const errorMsg = error?.response?.data?.message || error?.message || '分析失败'
        assistantMessage.content = `分析失败：${errorMsg}`
        this.$message.error(errorMsg)
      } finally {
        this.aiAnalyzing = false
        this.scrollChatToBottom()
      }
    },
    handleChatEnter(event) {
      if (event && event.shiftKey) {
        return
      }
      if (event && event.preventDefault) {
        event.preventDefault()
      }
      this.sendAiQuestion()
    },
    async sendAiQuestion() {
      if (!this.aiSessionId) {
        this.$message.warning('请先点击“分析”，生成会话后再提问')
        return
      }
      if (this.currentAiImageId && this.analyzedImageId && this.currentAiImageId !== this.analyzedImageId) {
        this.$message.warning('当前选择了新图片，请先重新点击“分析”')
        return
      }
      const question = (this.aiQuestion || '').trim()
      if (!question) {
        return
      }

      this.aiMessages.push({ role: 'user', content: question })
      this.aiQuestion = ''
      this.aiChatLoading = true
      const assistantMessage = { role: 'assistant', content: '' }
      this.aiMessages.push(assistantMessage)
      this.scrollChatToBottom()

      try {
        await chatGalaxyStreamAPI({
          sessionId: this.aiSessionId,
          question,
        }, (event) => {
          if (!event || !event.type) {
            return
          }
          if (event.type === 'chunk') {
            assistantMessage.content += event.content || ''
          } else if (event.type === 'error') {
            assistantMessage.content = `对话失败：${event.message || '未知错误'}`
          }
          this.scrollChatToBottom()
        })
        if (!assistantMessage.content) {
          assistantMessage.content = 'AI 未返回内容'
        }
      } catch (error) {
        const errorMsg = error?.response?.data?.message || error?.message || '对话失败'
        assistantMessage.content = `对话失败：${errorMsg}`
      } finally {
        this.aiChatLoading = false
        this.scrollChatToBottom()
      }
    },
    extractImageIdByIndex(index) {
      if (!this.dataFull[index]) {
        return ''
      }
      const directImageId = (this.dataFull[index].imageId || '').trim()
      if (directImageId) {
        return directImageId
      }
      if (!this.dataFull[index].picPath) {
        return ''
      }
      return this.extractImageIdFromPath(this.dataFull[index].picPath)
    },
    getSubmissionImageRef(index) {
      const item = this.dataFull[index]
      if (!item) {
        return ''
      }
      const imageId = (item.imageId || '').trim()
      if (imageId) {
        return imageId
      }
      if (item.id !== null && item.id !== undefined && item.id !== '') {
        return String(item.id)
      }
      return this.extractImageIdByIndex(index)
    },
    extractImageIdFromPath(path) {
      const rawPath = (path || '').replace(/\\/g, '/')
      const fileName = rawPath.split('/').pop() || ''
      const cropMatch = fileName.match(/^(.*)_crop\.(jpg|jpeg|png)$/i)
      if (cropMatch && cropMatch[1]) {
        return cropMatch[1]
      }
      return fileName.replace(/\.(jpg|jpeg|png)$/i, '')
    },
    resetAiConversation() {
      this.aiSessionId = ''
      this.analyzedImageId = ''
      this.currentAiImageId = ''
      this.aiQuestion = ''
      this.aiAnalyzing = false
      this.aiChatLoading = false
      this.aiMessages = [
        { role: 'assistant', content: '请选择一张图片，点击“分析”后即可开始 AI 对话。' }
      ]
    },
    escapeHtml(text) {
      return String(text || '').replace(/[&<>"']/g, (char) => {
        const entityMap = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        }
        return entityMap[char] || char
      })
    },
    parseInlineMarkdown(text) {
      let safe = this.escapeHtml(text)
      const inlineCodeCache = []

      safe = safe.replace(/`([^`]+)`/g, (_, code) => {
        const index = inlineCodeCache.push(code) - 1
        return `@@INLINE_CODE_${index}@@`
      })

      safe = safe.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
        '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
      safe = safe.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      safe = safe.replace(/__([^_]+)__/g, '<strong>$1</strong>')
      safe = safe.replace(/\*([^*\n]+)\*/g, '<em>$1</em>')
      safe = safe.replace(/_([^_\n]+)_/g, '<em>$1</em>')
      safe = safe.replace(/~~([^~]+)~~/g, '<del>$1</del>')

      safe = safe.replace(/@@INLINE_CODE_(\d+)@@/g, (_, index) => {
        return `<code>${inlineCodeCache[Number(index)] || ''}</code>`
      })
      return safe
    },
    renderMarkdown(text) {
      const source = String(text || '').replace(/\r\n/g, '\n')
      if (!source.trim()) {
        return '<p></p>'
      }

      const codeBlocks = []
      let markdown = source.replace(/```([a-zA-Z0-9_-]+)?\n([\s\S]*?)```/g, (_, lang, code) => {
        const index = codeBlocks.push({
          lang: (lang || '').trim(),
          code: this.escapeHtml(code).replace(/\n$/, ''),
        }) - 1
        return `@@CODE_BLOCK_${index}@@`
      })

      const lines = markdown.split('\n')
      let html = ''
      let inUl = false
      let inOl = false

      const closeLists = () => {
        if (inUl) {
          html += '</ul>'
          inUl = false
        }
        if (inOl) {
          html += '</ol>'
          inOl = false
        }
      }

      lines.forEach((line) => {
        const trimmed = line.trim()
        const codeBlockMatch = trimmed.match(/^@@CODE_BLOCK_(\d+)@@$/)
        if (codeBlockMatch) {
          closeLists()
          const block = codeBlocks[Number(codeBlockMatch[1])]
          const langClass = block.lang ? ` class="language-${block.lang}"` : ''
          html += `<pre><code${langClass}>${block.code}</code></pre>`
          return
        }

        if (!trimmed) {
          closeLists()
          return
        }

        const unorderedMatch = trimmed.match(/^[-*+]\s+(.+)$/)
        if (unorderedMatch) {
          if (inOl) {
            html += '</ol>'
            inOl = false
          }
          if (!inUl) {
            html += '<ul>'
            inUl = true
          }
          html += `<li>${this.parseInlineMarkdown(unorderedMatch[1])}</li>`
          return
        }

        const orderedMatch = trimmed.match(/^\d+\.\s+(.+)$/)
        if (orderedMatch) {
          if (inUl) {
            html += '</ul>'
            inUl = false
          }
          if (!inOl) {
            html += '<ol>'
            inOl = true
          }
          html += `<li>${this.parseInlineMarkdown(orderedMatch[1])}</li>`
          return
        }

        const quoteMatch = trimmed.match(/^>\s+(.+)$/)
        if (quoteMatch) {
          closeLists()
          html += `<blockquote>${this.parseInlineMarkdown(quoteMatch[1])}</blockquote>`
          return
        }

        const headingMatch = trimmed.match(/^(#{1,3})\s+(.+)$/)
        if (headingMatch) {
          closeLists()
          const level = headingMatch[1].length
          html += `<h${level}>${this.parseInlineMarkdown(headingMatch[2])}</h${level}>`
          return
        }

        closeLists()
        html += `<p>${this.parseInlineMarkdown(trimmed)}</p>`
      })

      closeLists()
      return html || '<p></p>'
    },
    scrollChatToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatScroll
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    // 提交
    fun3() {
      // 前置工作
        this.merge = [...this.aArray, ...this.bArray, ...this.cArray, ...this.ycArray, ...this.xxArray]
      if (this.merge.length >= 12) {
        for (const index of this.aArray) {
          const imageRef = this.getSubmissionImageRef(index)
          if (imageRef) this.newArray0.push(imageRef)
        }
        for (const index of this.bArray) {
          const imageRef = this.getSubmissionImageRef(index)
          if (imageRef) this.newArray1.push(imageRef)
        }
        for (const index of this.cArray) {
          const imageRef = this.getSubmissionImageRef(index)
          if (imageRef) this.newArray2.push(imageRef)
        }
        for (const index of this.ycArray) {
          const imageRef = this.getSubmissionImageRef(index)
          if (imageRef) this.newArray3.push(imageRef)
        }
        for (const index of this.xxArray) {
          const imageRef = this.getSubmissionImageRef(index)
          if (imageRef) this.newArray4.push(imageRef)
        }
        for (const index of this.arr4) {
          if (!this.merge.includes(index)) {
            const imageRef = this.getSubmissionImageRef(index)
            if (imageRef) this.newArray5.push(imageRef)
          }
        }


        // this.list1.forEach((value, i) => {
        //   this.ii.push(i)
        // })
        // for (let iterator of this.ii) {
        //   if (!this.merge.includes(iterator)) {
        //     this.remainder.push(iterator)
        //   }
        // }
        // for (const index of this.remainder) {
        //   this.newArray5.push(this.dataFull[index].id)
        // }

        var classTime = (new Date() - this.time1) / 1000

        // 接口调用
        // todo
        this.getResults(classTime)
        this.disabledS = true
        this.tishi = 'rgb(160,207,255)'
        // 重置属性
        this.chooseA = 0
        this.chooseB = 0
        this.chooseC = 0
        this.chooseYC = 0
        this.chooseXing = 0
        this.selected = [];
        this.aaaa = ''
        this.bbbb = ''
        this.newArray0 = [];
        this.newArray1 = [];
        this.newArray2 = [];
        this.newArray3 = [];
        this.newArray4 = [];
        this.newArray5 = [];
        this.remainder = [];
        this.merge = [];
        this.aArray = [];
        this.bArray = [];
        this.cArray = [];
        this.xxArray = [];
        this.ycArray = [];
        this.dataFull = [];
        this.disabledS = true
        this.tishi = 'rgb(160,207,255)'
        this.is = 3
        this.class0 = '00.00'
        this.class1 = '00.00'
        this.class2 = '00.00'
        this.class3 = '00.00'
        this.timebool = false
        for (var i = 0; i < 24; i++) {
          this.$refs.zz[i].style.display = "none";
          this.$refs.zz[i].style.border = "none";
        }
      } else {
        this.$alert("分类图片少于12张,请继续分类", '提示', {
          confirmButtonText: '是',
          type: 'warning',
          showClose: false,
        });
      }
    },
    A() {
      for (const i of this.selected) {
        this.aArray.push(i)
      }
      // todo
      if (this.aArray.length != 0) {
        this.chooseA = 1
      }
      if (this.chooseA == 1) {
        for (const i of this.aArray) {
          this.$refs.zz[i].style.background = "rgba(255, 87, 51,0.4)";
          this.bbbb = "none"
        }
        this.selected = [];
      }

    },
    B() {
      for (const i of this.selected) {
        this.bArray.push(i)
      }
      // todo
      if (this.bArray.length != 0) {
        this.chooseB = 1
      }
      if (this.chooseB == 1) {
        for (const i of this.bArray) {
          this.$refs.zz[i].style.background = "rgba(63, 81, 181,0.4)";
          this.bbbb = "none"
        }
        this.selected = [];
      }


    },
    C() {
      for (const i of this.selected) {
        this.cArray.push(i)
      }
      // todo

      if (this.cArray.length != 0) {
        this.chooseC = 1

      }
      if (this.chooseC == 1) {
        for (const i of this.cArray) {
          this.$refs.zz[i].style.background = "rgba(76,175,80,0.4)";
          this.bbbb = "none"
        }
      }
      this.selected = [];

    },
    // 撤销

    cancel() {
      this.visible = false
    }
  },
};
</script>

<style lang="scss" scoped>
* {
  text-decoration: none;
  list-style: none;
}

.class-page {
  width: 100%;
  min-height: 700px;
  padding: 20px 24px;
  box-sizing: border-box;
  background: #ffffff;
}

.layout-shell {
  width: 100%;
  max-width: 1520px;
  margin: 0 auto;
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.category-panel {
  width: 165px;
  flex: 0 0 165px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.work-panel {
  flex: 0 0 820px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ts {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border-radius: 5px;
  color: #111111;
  font-weight: 700;
  border: 2px solid gray;
}

/* Element UI 默认会给相邻按钮加 margin-left: 10px，这里在分类栏中清零 */
.category-panel .el-button,
.category-panel .el-button+.el-button {
  margin-left: 0 !important;
}

.ts:hover {
  color: white;
  background-color: rgb(120, 177, 255);
}

.grid-stage {
  width: 100%;
  padding: 10px;
  border: 1px solid #d6d8df;
  border-radius: 8px;
  background: #f8fafc;
  box-sizing: border-box;
}

.gird {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(6, 128px);
  grid-template-rows: repeat(4, 128px);
  gap: 6px;
  width: 798px;
  height: 530px;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0 auto;
  background: #ffffff;
}

.gird-item {
  position: relative;
  box-sizing: border-box;
  width: 128px;
  height: 128px;
}

.grid-image {
  display: block;
}

.zz {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  gap: 14px;
}

.action-btn {
  width: 128px;
  height: 40px;
  border-radius: 6px;
}

.chat-panel {
  width: 320px;
  flex: 0 0 320px;
  height: 580px;
  border: 1px solid #b9bfd2;
  border-radius: 8px;
  overflow: hidden;
  background: #919ab6;
  display: flex;
  flex-direction: column;
}

.chat-header {
  width: 100%;
  height: 44px;
  background-color: rgb(171, 174, 188);
  color: white;
  font-size: 18px;
  text-align: center;
  line-height: 44px;
}

.chat-body {
  flex: 1;
  min-height: 0;
  background-color: rgb(145, 154, 182);
  font-size: 14px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.ai-status {
  line-height: 20px;
  color: white;
  font-size: 12px;
  margin-bottom: 8px;
}

.chat-messages {
  flex: 1;
  min-height: 0;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  padding: 6px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.55) rgba(255, 255, 255, 0.12);
}

.chat-messages::-webkit-scrollbar {
  width: 9px;
}

.chat-messages::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 8px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.7), rgba(199, 217, 255, 0.65));
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.85), rgba(214, 225, 255, 0.85));
}

.chat-item {
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 4px;

  .chat-role {
    font-weight: 700;
    margin-bottom: 4px;
    color: #fff;
    font-size: 13px;
  }

  .chat-content {
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 14px;
    line-height: 1.72;
  }
}

.chat-item.assistant {
  background: rgba(255, 255, 255, 0.2);

  .chat-content {
    color: #f4f6ff;
  }
}

.chat-item.user {
  background: rgba(24, 144, 255, 0.35);

  .chat-content {
    color: #ffffff;
  }
}

.chat-loading {
  color: #ffffff;
  font-size: 13px;
  padding: 4px 0;
}

.chat-content.markdown ::v-deep p {
  margin: 0 0 8px;
}

.chat-content.markdown ::v-deep ul,
.chat-content.markdown ::v-deep ol {
  margin: 0 0 8px 18px;
  padding: 0;
}

.chat-content.markdown ::v-deep li {
  margin-bottom: 4px;
}

.chat-content.markdown ::v-deep h1,
.chat-content.markdown ::v-deep h2,
.chat-content.markdown ::v-deep h3 {
  margin: 6px 0 8px;
  font-size: 15px;
  line-height: 1.45;
}

.chat-content.markdown ::v-deep code {
  padding: 1px 5px;
  border-radius: 4px;
  font-family: Consolas, 'Courier New', monospace;
  background: rgba(0, 0, 0, 0.25);
  color: #e9f2ff;
  font-size: 13px;
}

.chat-content.markdown ::v-deep pre {
  margin: 8px 0;
  padding: 8px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.35);
  overflow-x: auto;
}

.chat-content.markdown ::v-deep pre code {
  background: transparent;
  padding: 0;
  font-size: 13px;
}

.chat-content.markdown ::v-deep blockquote {
  margin: 8px 0;
  padding: 6px 10px;
  border-left: 3px solid rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.08);
}

.chat-content.markdown ::v-deep a {
  color: #d8ecff;
  text-decoration: underline;
}

.chat-input-wrap {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.send-btn {
  align-self: flex-end;
}

@media (max-width: 1420px) {
  .layout-shell {
    flex-wrap: wrap;
  }

  .category-panel {
    width: 100%;
    flex-basis: 100%;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .ts {
    width: 150px;
  }

  .work-panel {
    flex: 1 1 auto;
    min-width: 860px;
  }

  .chat-panel {
    width: 100%;
    flex-basis: 100%;
    height: 460px;
  }
}
</style>
